import { Button, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useCallback } from "react";
import { useGetRole } from "../../../lib/hooks/getRole";
import USER_ROLES from "../../../types/UserRoles";

type HeaderProps = {
  title: string;
  navigateTo: string;
};

export const Header = ({ title, navigateTo }: HeaderProps) => {
  const navigate = useNavigate();

  const [role] = useGetRole();

  const onBack = useCallback(
    () => navigate(navigateTo),
    [navigate, navigateTo],
  );

  return (
    <Row className="align-center profile-header">
      {role !== USER_ROLES.INTEGRATION_RECEPTIONIST && (
        <Button
          shape="circle"
          icon={<ArrowLeftOutlined />}
          size="large"
          className="back-btn mr-6"
          onClick={onBack}
        />
      )}
      <h3 className="h h3">{title}</h3>
    </Row>
  );
};
